import { getCurrentMarket } from 'shared/domains/markets/config';
export const links = {
    homepage: '',
    about: '',
    extSharingTerms: '',
    extSharingPrivacy: '',
};
export const externalLinks = {
    terms: 'https://miramis.co/terms',
    dataProcessingAgreement: 'https://miramis.co/terms-of-service',
    contact: 'https://miramis.co/support-tickets',
    sales: 'https://miramis.co/contact-sales',
    privacy: 'https://miramis.co/privacy-policy',
    acceptableUsePolicy: 'https://miramis.co/acceptable-use-policy',
    pricing: 'https://miramis.co/pricing',
    eSigning: 'https://miramis.co/electronic-signature-software',
    billing: {
        se: 'https://billing.stripe.com/p/login/eVqdR8eo861zemX2ehenS00',
        uk: 'https://billing.stripe.com/p/login/cNi14nf8X2tu5C09aD2go00',
    },
};
function resolveLink(value, market) {
    return typeof value === 'string' ? value : value[market === 'se' ? 'se' : 'uk'];
}
export function useGetLinks() {
    const marketCode = getCurrentMarket().code;
    const linkObject = {};
    Object.entries(links).forEach(([key, value]) => {
        linkObject[key] = `${process.env.WEBSITE_URL}/${resolveLink(value, marketCode)}`;
    });
    Object.entries(externalLinks).forEach(([key, value]) => {
        linkObject[key] = resolveLink(value, marketCode);
    });
    return linkObject;
}
